import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import BaseModal from '../../components/modals/BaseModal';
import { useLoadingContext } from '../../context/loading/LoadingContext';
import { useUserContext } from '../../context/user_context/UserContext';
import { addBug as addFeedback } from '../../repository/BugReportsDAO';
import { ToastType, useToast } from '../../context/toast/ToastContext';
import { serverTimestamp } from "firebase/firestore";
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const ReportFeedbackModal = ({ show, onHide }) => {
    const [type, setType] = useState("");
    const [description, setDescription] = useState("");
    const { setLoadingData } = useLoadingContext();
    const { firebaseUser } = useUserContext();
    const { showToast } = useToast();
    const { t } = useTranslation();

    const feedbackTypes = [
        { value: "bug", label: t(StringKeys.BUG_REPORT) },
        { value: "feature", label: t(StringKeys.FEATURE_REQUEST) },
        { value: "general", label: t(StringKeys.GENERAL_FEEDBACK) },
    ];

    const handleSubmit = async () => {
        if (!type) {
            showToast(t(StringKeys.PLEASE_SELECT_FEEDBACK_TYPE), ToastType.DANGER);
            return;
        }

        setLoadingData(true);
        
        const feedback = {
            type,
            description,
            user_id: firebaseUser.uid,
            date_submitted: serverTimestamp(),
        };
    
        try {
            const result = await addFeedback(feedback);
    
            if (result.success) {
                showToast(t(StringKeys.THANK_YOU_FOR_YOUR_FEEDBACK), ToastType.SUCCESS);
                resetForm();
            } else {
                showToast(t(StringKeys.FAILED_TO_SUBMIT_FEEDBACK_PLEASE_TRY_AGAIN), ToastType.DANGER);
            }
        } catch (error) {
            showToast(t(StringKeys.FAILED_TO_SUBMIT_FEEDBACK_PLEASE_TRY_AGAIN), ToastType.DANGER);
        } finally {
            setLoadingData(false);
            onHide();
        }
    };

    const resetForm = () => {
        setType("");
        setDescription("");
    };

    const actions = (
        <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
    );

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            title={t(StringKeys.FEEDBACK)}
            actions={actions}
        >
            <TextField
                select
                margin="dense"
                id="type"
                label={t(StringKeys.SELECT_FEEDBACK_TYPE)}
                fullWidth
                variant="outlined"
                value={type}
                onChange={(e) => setType(e.target.value)}
            >
                {feedbackTypes.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                margin="dense"
                id="description"
                label={t(StringKeys.DESCRIPTION)}
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />         
        </BaseModal>
    );
};

export default ReportFeedbackModal;
